import TextField, { textFieldClasses } from '@mui/material/TextField';
import { inputClasses } from '@mui/material/Input';

import styled from 'shared/utils/styled';

export const StyledTextField = styled(TextField)(() => ({
  [`&.${textFieldClasses.root}`]: {
    width: '100%',
    border: '1px solid rgba(34, 64, 96, .2)',
  },
  [`& .${inputClasses.root}`]: {
    [`& .${inputClasses.input}`]: {
      padding: 9,
      fontSize: 14,
      fontFamily: 'NeoSansStd',
      color: '#224060',
    },
    [`& .${inputClasses.disabled}`]: {
      background: 'rgba(211, 211, 211, .2)',
      opacity: 0.5,
    },
  },
}));
